import { Placement, Order } from 'root/consts';

export const getItemNameAndIconOrder = (
  placement: Placement
): { featuredItemNameOrder: Order; featuredItemIconOrder: Order } => {
  switch (placement) {
    case Placement.After:
      return { featuredItemIconOrder: Order.Second, featuredItemNameOrder: Order.First };
    case Placement.Before:
    default:
      return { featuredItemIconOrder: Order.First, featuredItemNameOrder: Order.Second };
  }
};
